import { useContext } from "react";
import { ReceiptsContext } from "../contexts/ReceiptsContext";

export function useReceipt() {
  const context = useContext(ReceiptsContext);

  return context;
}